/* Wodhaus — pequenos comportamentos próprios (14/10/2026, plano do tema). Sem dependências. */
(function () {
  'use strict';

  /* 1. Datas de entrega em DIAS ÚTEIS (seg–sex), na língua da página.
        Cada <… data-wod-date="N"> recebe hoje + N dias úteis. Encomenda ao fim de semana conta a partir de segunda.
        A caixa [data-wod-eta] só aparece depois de preenchida (sem JS fica escondida). */
  function addBusinessDays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }
  var fmtCache = {};
  function fmtFor(lang) {
    lang = lang || document.documentElement.lang || 'en';
    if (fmtCache[lang]) return fmtCache[lang];
    var opts = { weekday: 'short', day: 'numeric', month: 'short' };
    try { fmtCache[lang] = new Intl.DateTimeFormat(lang, opts); }
    catch (e) { fmtCache[lang] = new Intl.DateTimeFormat(document.documentElement.lang || 'en', opts); }
    return fmtCache[lang];
  }
  function fillEta(box) {
    var fmt = fmtFor(box.getAttribute('data-lang'));
    var now = new Date();
    var els = box.querySelectorAll('[data-wod-date]');
    for (var i = 0; i < els.length; i++) {
      var n = parseInt(els[i].getAttribute('data-wod-date'), 10);
      if (!isNaN(n)) els[i].textContent = fmt.format(addBusinessDays(now, n));
    }
    box.setAttribute('data-wod-filled', '');
    box.hidden = false;
  }
  function fillAll(root) {
    var boxes = (root || document).querySelectorAll('[data-wod-eta]:not([data-wod-filled])');
    for (var i = 0; i < boxes.length; i++) fillEta(boxes[i]);
    initFolds(root);
    initCompl(root);
  }

  /* 2. Mudança de variante: o Horizon devolve o HTML da secção; trocam-se os nossos blocos ([data-wod-swap]). */
  document.addEventListener('shopify:product:select', function (ev) {
    if (!ev || !ev.promise || !ev.target || !ev.target.closest || ev.target.closest('product-card')) return;
    ev.promise.then(function (res) {
      var html = res && res.detail && res.detail.html;
      if (!html || !html.querySelectorAll) return;
      var novos = html.querySelectorAll('[data-wod-swap]');
      for (var i = 0; i < novos.length; i++) {
        var id = novos[i].getAttribute('data-wod-swap');
        var velho = document.querySelector('[data-wod-swap="' + id + '"]');
        if (velho) velho.innerHTML = novos[i].innerHTML;
      }
      fillAll(document);
    }).catch(function () {});
  });

  /* 3. Texto SEO dobrado: «Read more» / «Show less». */
  function initFolds(root) {
    var boxes = (root || document).querySelectorAll('[data-wod-fold]:not([data-wod-fold-ready])');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      box.setAttribute('data-wod-fold-ready', '');
      var body = box.querySelector('.wod-seo__body');
      var btn = box.querySelector('[data-wod-fold-btn]');
      if (!body || !btn) continue;
      if (body.scrollHeight <= body.clientHeight + 4) { btn.hidden = true; box.classList.add('is-open'); continue; }
      btn.addEventListener('click', function (e) {
        var b = e.currentTarget, bx = b.closest('[data-wod-fold]');
        var open = bx.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
      });
    }
  }

  /* 4. Gaveta: no máximo 1 sugestão complementar (Search & Discovery). Sem complementar, nada. */
  var complCache = {};
  function initCompl(root) {
    var slots = (root || document).querySelectorAll('[data-wod-compl]:not([data-wod-compl-ready])');
    for (var i = 0; i < slots.length; i++) {
      (function (slot) {
        slot.setAttribute('data-wod-compl-ready', '');
        var pid = slot.getAttribute('data-product-id');
        if (!pid) return;
        var url = (slot.getAttribute('data-url') || '/recommendations/products') +
          '?product_id=' + pid + '&limit=1&intent=complementary&section_id=wod-sugestao';
        var p = complCache[pid] || (complCache[pid] = fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }));
        p.then(function (txt) {
          if (!txt) return;
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var res = doc.querySelector('[data-wod-compl-result]');
          if (!res) return;
          var inCart = slot.getAttribute('data-in-cart') || '';
          if (inCart.indexOf(',' + res.getAttribute('data-pid') + ',') !== -1) return;
          slot.innerHTML = res.innerHTML;
          slot.hidden = false;
        });
      })(slots[i]);
    }
  }

  /* 5. Seguir encomenda: abre o 17TRACK numa nova aba com o número. */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-wod-track')) return;
    var input = form.querySelector('input[name="nums"]');
    var num = input ? input.value.replace(/\s+/g, '').trim() : '';
    if (!num) return;
    ev.preventDefault();
    window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
  });

  /* 6. País e língua no rodapé: muda ao escolher. */
  document.addEventListener('change', function (ev) {
    var el = ev.target;
    if (el && el.hasAttribute && el.hasAttribute('data-wod-autosubmit') && el.form) el.form.submit();
  });

  /* 7. Menu: a lista do submenu abre por baixo do item escolhido. */
  function placeDropdown(item) {
    var list = item.querySelector(':scope > .menu-list__submenu .wod-dd');
    if (!list || item.getAttribute('slot') === 'overflow') return;
    list.style.setProperty('--wod-dd-x', '0px');
    var base = list.getBoundingClientRect().left;
    var parent = list.parentElement.getBoundingClientRect();
    var x = item.getBoundingClientRect().left - base;
    var maxX = parent.right - base - list.getBoundingClientRect().width - 16;
    x = Math.max(0, Math.min(x, maxX));
    list.style.setProperty('--wod-dd-x', Math.round(x) + 'px');
  }
  function onMenuEnter(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var item = t.closest('.wod-dd-menu .menu-list__list-item');
    if (item) placeDropdown(item);
  }
  document.addEventListener('pointerover', onMenuEnter);
  document.addEventListener('focusin', onMenuEnter);

  /* 8. Wodhaus 22/10: o número do carrinho no cabeçalho não conta o seguro de envio (o Horizon actualiza-o por JS com o total). */
  var SEG = 'shipping-protection';
  function acertaBolha() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = 0; (c.items || []).forEach(function (it) { if (it.handle !== SEG) n += it.quantity; });
      [].forEach.call(document.querySelectorAll('.cart-bubble__text-count'), function (el) { el.textContent = n; el.classList.toggle('hidden', n === 0); var b = el.closest('.cart-bubble'); if (b) b.classList.toggle('visually-hidden', n === 0); });
    }).catch(function () {});
  }
  document.addEventListener('cart:update', function () { setTimeout(acertaBolha, 60); });

  function init() {
    fillAll(document);
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; fillAll(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
